import React, { useEffect, useState } from "react";
import { db } from "../../firebase/config";
import { collection, addDoc, getDocs, deleteDoc, doc } from "firebase/firestore";
import QRCode from "qrcode";
import { useAuth } from "../../context/AuthContext";
import "./AdminPanel.css";

const ADMIN_UID = "I41qVJFkMhUcs2j3Gl8ytQx6qx33"; // your admin UID

export default function AdminPanel() {
  const { currentUser } = useAuth();

  const [invites, setInvites] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch invite list
  const fetchInvites = async () => {
    const snap = await getDocs(collection(db, "invites"));
    const list = snap.docs.map((d) => ({
      id: d.id,
      ...d.data(),
    }));
    setInvites(list);
  };

  // Generate new invite
  const generateInvite = async () => {
    setLoading(true);

    await addDoc(collection(db, "invites"), {
      used: false,
      createdAt: Date.now(),
      usedBy: null,
      usedAt: null,
    });

    setLoading(false);
    fetchInvites();
  };

  // Delete invite
  const removeInvite = async (id) => {
    await deleteDoc(doc(db, "invites", id));
    fetchInvites();
  };

  // Download QR code
  const downloadQR = async (inviteId) => {
    const link = `${window.location.origin}/invite/${inviteId}`;
    const qrImage = await QRCode.toDataURL(link);

    const a = document.createElement("a");
    a.href = qrImage;
    a.download = `invite-${inviteId}.png`;
    a.click();
  };

  useEffect(() => {
    if (currentUser?.uid === ADMIN_UID) {
      fetchInvites();
    }
  }, [currentUser]);

  if (!currentUser) return null;

  if (currentUser.uid !== ADMIN_UID) {
    return <h2 className="admin-denied">Access Denied</h2>;
  }

  return (
    <div className="admin-container">
      <h1 className="admin-title">Nukkad Admin Panel</h1>

      <button className="create-btn" onClick={generateInvite} disabled={loading}>
        {loading ? "Creating..." : "Generate Invite Link"}
      </button>

      <div className="invite-list">
        {invites.map((inv) => {
          const url = `${window.location.origin}/invite/${inv.id}`;

          return (
            <div className="invite-card" key={inv.id}>
              <p className="invite-id">
                <strong>Invite ID:</strong> {inv.id}
              </p>

              <p className="invite-status">
                <strong>Used By:</strong>{" "}
                {inv.usedBy ? (
                  <>
                    <div>Email: {inv.usedBy.email || "—"}</div>
                    <div>Phone: {inv.usedBy.phone || "—"}</div>
                    <div>
                      Joined At:{" "}
                      {inv.usedBy.joinedAt
                        ? inv.usedBy.joinedAt.seconds
                          ? new Date(inv.usedBy.joinedAt.seconds * 1000).toLocaleString()
                          : new Date(inv.usedBy.joinedAt).toLocaleString()
                        : "—"}
                    </div>
                  </>
                ) : (
                  "— Not Used —"
                )}
              </p>

              <div className="invite-actions">
                <button
                  className="copy-btn"
                  onClick={() => navigator.clipboard.writeText(url)}
                >
                  Copy Link
                </button>

                <button className="qr-btn" onClick={() => downloadQR(inv.id)}>
                  QR Code
                </button>

                <button className="delete-btn" onClick={() => removeInvite(inv.id)}>
                  Delete
                </button>
              </div>

              <small className="invite-url">{url}</small>
            </div>
          );
        })}
      </div>
    </div>
  );
}
